import React, { FunctionComponent } from 'react';
import { useParams } from 'react-router-dom';
import { GranulesSummary } from '../granulesSummary/GranulesSummary';
import { GranulesTable } from '../granulesTable/GranulesTable';

type GranulesProps = {};

type GranulesParams = {
  kapsuleId: string;
};

export const Granules: FunctionComponent<GranulesProps> = () => {
  const { kapsuleId } = useParams<GranulesParams>();

  return (
    <div style={{ background: 'rgba(255, 255, 255, 0.3)' }}>
      <GranulesSummary  kapsuleId={kapsuleId} />
      <GranulesTable kapsuleId={kapsuleId} />
    </div>
  );
};
